export enum UserInfoCookieAppName {
    FMS = 'FMS',
    MRT = 'MRT',
    MRT_FR = 'MRT',
    MRT_DASHBOARD = 'MRT_DASHBOARD',
    ORD = 'ORD',
    ORD_ADMIN = 'ORD_ADMIN',
    MOBICLEAR = 'MOBICLEAR',
    DIVC = 'DIVC',
    REI = 'REI',
    MGT = 'MGT'
}
